import projectManage from './projectManage';
import vendor from './vendor';
import outsourcing from './outsourcing';

export default (siteName) => [
    // ------------------- 專案、客戶 -------------------
    ...projectManage(siteName),
    {
        path: 'project-type',
        name: 'project-type',
        component: () => import('../../components/dashboard/ProjectType/index.vue'),
        meta: {
            title: `專案類型管理${siteName}`,
            activeMenu: 'project',
            activeSubMenu: 'project-type',
        },
    },
    ...vendor(siteName),

    // ------------------- 廠商 -------------------
    ...outsourcing(siteName),
    {
        path: 'outsourcing-type',
        name: 'outsourcing-type',
        component: () => import('../../components/dashboard/Settings/OutsourcingType/index.vue'),
        meta: {
            title: `委外類型管理${siteName}`,
            activeMenu: 'settings',
        },
    },
];
